import { h, Component } from 'preact';

class SessionWarningBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            retrying: false,
        };
    }

    handleRetry = async () => {
        this.setState({ retrying: true });
        const { onRetry } = this.props;
        if (onRetry) {
            await onRetry();
        }
        this.setState({ retrying: false });
    }

    render() {
        const { onDismiss } = this.props;
        const { retrying } = this.state;

        return (
            <div class='alert alert-warning alert-dismissible fade show d-flex align-items-center mb-2' role='alert'>
                <i class='fa-solid fa-wifi me-2'></i>
                <span class='me-2'>
                    Connection issue — session refresh failed. Your work is safe.
                </span>
                <button
                    type='button'
                    class='btn btn-sm btn-warning me-2'
                    onClick={this.handleRetry}
                    disabled={retrying}
                >
                    {retrying ? (
                        <><span class='spinner-border spinner-border-sm me-1' role='status' aria-hidden='true'></span>Retrying...</>
                    ) : 'Retry now'}
                </button>
                <button type='button' class='btn-close' onClick={onDismiss} aria-label='Close'></button>
            </div>
        );
    }
}

export default SessionWarningBanner;
